export enum PosthogFeatureFlag {
  TASKS_SYSTEM = 'tasks_system',
  BTL_CASE_SIDEBAR = 'btl_case_sidebar',
  OO_CASE_NEW_UI = 'oo_case_new_ui',
  OO_CASE_NEW_SECTIONS = 'oo_case_new_sections',
}
